<template>
    <div class="blob" :style="cssProps">
        <span class="clickarea">{{label}}</span>
    </div>
</template>

<script>
  export default {
    props: ['label','link','color', 'width', 'height'],
    computed: {
      cssProps(){ return {
        '--blobcolor':this.color,
        '--blowWidth':this.width + "px",
        '--blobHeight':this.height + "px"
      }
      }
    }
  }

</script>

<style>

  .clickarea{
  /* Expand click area blob */
    display: inline-block;
    position: relative;    
    z-index: 1;     
    padding: calc(var(--blobHeight)/3);     
    margin: -calc(var(--blobHeight)/3); 
        
  }

  .blob{
    display: flex;
    justify-content: center;
    align-items: center;
    mask:url("../assets/img/blob.svg");
    mask-size: contain;
    mask-repeat:no-repeat;
    width: var(--blowWidth);
    height:var(--blobHeight);
    background-color: var(--blobcolor);    
  }
  .blob span {
    color:white;
    font-family: Montserrat;
    font-size: 1.3rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.85;
    letter-spacing: normal;
    text-align: center;
    
  }

@media only screen and (min-width: 992px) {
  .blob{
      width: calc(var(--blowWidth)*1.5);
      height:calc(var(--blobHeight)*1.5);
    }

}
@media only screen and (min-width: 1200px) {

 .clickarea{
   padding: calc(var(--blowWidth)/2);     
   margin: -calc(var(--blowWidth)/2); 
 }


  .blob a{
    font-size: 1.6rem;
    line-height: 1.6;
  }
  .blob{
    width: calc(var(--blowWidth)*2.0);
    height:calc(var(--blobHeight)*2.0);
  }
  

}


</style>